/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/**
 * Forked from:
 * https://github.com/dixahq/elevio-chrome-integrations/blob/main/src/background/analytics/snowcat.ts
 *
 * Opted to disable these eslint rules so I can use the original code:
 *
 * - Prefer-rest-params
 * - @typescript-eslint/ban-ts-comment
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ElevioError } from '../utils';
import { snowcatAppId, snowcatNamespace, snowcatPlatform, snowcatUrl, } from './config';
export function setup() {
    if (process.env.NODE_ENV === 'test')
        return;
    loadSnowcat();
    setOptions();
}
export function trackSelfDescribingEvent(schema, data, url, languageId) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        if (process.env.NODE_ENV === 'test')
            return;
        if (!languageId) {
            throw ElevioError({
                context: 'Snowcat',
                feature: 'suggestions',
                message: `No languageId provided for ${JSON.stringify(data)}`,
            });
        }
        const { store } = yield import('store');
        const suggestions = store.getState().elevio
            .suggestions;
        const { companyUid, userId, userEmail: user_email } = suggestions;
        const app_version = VERSION;
        // Because events can be triggered before useEffect has a chance to run
        // let's make sure it's loaded before we fire events.
        if (!window.elevio_snowcat) {
            setup();
        }
        try {
            (_a = window.elevio_snowcat) === null || _a === void 0 ? void 0 : _a.call(window, 'setCustomUrl', url);
            (_b = window.elevio_snowcat) === null || _b === void 0 ? void 0 : _b.call(window, 'trackSelfDescribingEvent', {
                schema,
                data,
            }, [
                {
                    schema: 'iglu:com.elevio/context/jsonschema/1-0-1',
                    data: {
                        customer_uid: companyUid,
                        user_id: userId === null || userId === void 0 ? void 0 : userId.toString(),
                        language_id: languageId,
                        user_email,
                        app_version,
                    },
                },
            ]);
        }
        catch (error) {
            // This is here in case elevio_snowcat hasn't loaded yet.
        }
    });
}
function loadSnowcat() {
    const scriptUrl = `${window.location.origin}/assets/libs/javascript/snowplow.js`;
    (function (p, l, o, w, i, n, g) {
        // @ts-ignore
        if (!p[i]) {
            // @ts-ignore
            p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || [];
            // @ts-ignore
            p.GlobalSnowplowNamespace.push(i);
            // @ts-ignore
            p[i] = function () {
                // @ts-ignore
                (p[i].q = p[i].q || []).push(arguments);
            };
            // @ts-ignore
            p[i].q = p[i].q || [];
            // @ts-ignore
            n = l.createElement(o);
            // @ts-ignore
            g = l.getElementsByTagName(o)[0];
            // @ts-ignore
            n.async = 1;
            // @ts-ignore
            n.src = w;
            // @ts-ignore
            g.parentNode.insertBefore(n, g);
        }
    })(window, document, 'script', scriptUrl, 'elevio_snowcat');
}
function setOptions() {
    window.elevio_snowcat('newTracker', snowcatNamespace || 'snowcat', snowcatUrl, {
        appId: snowcatAppId,
        platform: snowcatPlatform || 'web',
        cookieDomain: null,
        discoverRootDomain: true,
        cookieName: null,
        // encodeBase64: false,
        respectDoNotTrack: false,
        userFingerprint: true,
        userFingerprintSeed: 6385926734,
        // pageUnloadTimer: 0,
        forceSecureTracker: true,
        // eventMethod: 'post',
        // bufferSize: 1,
        maxPostBytes: 50000000,
        stateStorageStrategy: 'localStorage',
        connectionTimeout: 10000,
        contexts: {
            webPage: true,
            performanceTiming: false,
            gaCookies: false,
            geolocation: false,
        },
    });
    // @ts-ignore
    window.elevio_snowcat('setDebug', true);
}
export function setupUnload() {
    var _a;
    (_a = window.elevio_snowcat) === null || _a === void 0 ? void 0 : _a.call(window, 'flushBuffer');
}
